// 51免费漫画追更 - 首页 Mock 数据
// 注意：图片 URL 必须为完整硬编码字符串，禁止拼接。

export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  genre: string;
  latestChapter: string;
  updateTime: string;
  isNew?: boolean;
  hot?: boolean;
  tags: string[];
}

export const todayUpdates: Comic[] = [
  {
    id: 1,
    title: "灵域剑仙",
    author: "墨守成规",
    genre: "玄幻",
    latestChapter: "第 328 话 · 破界而来",
    updateTime: "10 分钟前",
    tags: ["今日更新", "热门连载"],
    cover: "https://readdy.ai/api/search-image?query=vibrant%20stylized%20chinese%20fantasy%20manga%20cover%20art%2C%20a%20young%20swordsman%20floating%20with%20glowing%20spiritual%20sword%20amid%20storm%20clouds%2C%20bold%20clean%20ink%20lines%2C%20warm%20orange%20and%20deep%20teal%20palette%2C%20dramatic%20lighting%2C%20modern%20digital%20comic%20illustration%2C%20high%20contrast%20and%20energetic%20composition&width=900&height=1200&seq=comic-01&orientation=portrait",
  },
  {
    id: 2,
    title: "都市异能觉醒",
    author: "雾里看花",
    genre: "都市",
    latestChapter: "第 512 话 · 闪电之夜",
    updateTime: "32 分钟前",
    hot: true,
    tags: ["今日更新", "都市异能"],
    cover: "https://readdy.ai/api/search-image?query=vibrant%20stylized%20urban%20superpower%20manga%20cover%20art%2C%20a%20confident%20young%20man%20in%20a%20city%20street%20surrounded%20by%20crackling%20electric%20energy%20and%20neon%20lights%2C%20bold%20clean%20lines%2C%20warm%20orange%20and%20teal%20palette%2C%20dramatic%20lighting%2C%20modern%20digital%20comic%20illustration%2C%20energetic%20composition&width=900&height=1200&seq=comic-02&orientation=portrait",
  },
  {
    id: 3,
    title: "星海远征",
    author: "极光旅人",
    genre: "科幻",
    latestChapter: "第 96 话 · 无归之地",
    updateTime: "1 小时前",
    tags: ["今日更新", "科幻新番"],
    cover: "https://readdy.ai/api/search-image?query=vibrant%20stylized%20sci-fi%20space%20manga%20cover%20art%2C%20a%20young%20astronaut%20captain%20standing%20before%20a%20glowing%20nebula%20and%20spaceship%20fleet%2C%20bold%20clean%20lines%2C%20warm%20orange%20and%20deep%20teal%20palette%2C%20cinematic%20lighting%2C%20modern%20digital%20comic%20illustration%2C%20epic%20composition&width=900&height=1200&seq=comic-03&orientation=portrait",
  },
  {
    id: 4,
    title: "剑与魔法学院",
    author: "半糖少盐",
    genre: "奇幻",
    latestChapter: "第 203 话 · 试炼开始",
    updateTime: "2 小时前",
    tags: ["今日更新", "奇幻冒险"],
    cover: "https://readdy.ai/api/search-image?query=vibrant%20stylized%20fantasy%20academy%20manga%20cover%20art%2C%20two%20students%20with%20sword%20and%20magic%20staff%20in%20front%20of%20a%20magical%20castle%20school%2C%20bold%20clean%20lines%2C%20warm%20orange%20and%20teal%20palette%2C%20dramatic%20lighting%2C%20modern%20digital%20comic%20illustration%2C%20lively%20composition&width=900&height=1200&seq=comic-04&orientation=portrait",
  },
  {
    id: 5,
    title: "逆转人生游戏",
    author: "弦上梦",
    genre: "悬疑",
    latestChapter: "第 87 话 · 第二个选择",
    updateTime: "3 小时前",
    tags: ["今日更新", "脑洞悬疑"],
    cover: "https://readdy.ai/api/search-image?query=vibrant%20stylized%20suspense%20game%20manga%20cover%20art%2C%20a%20mysterious%20figure%20surrounded%20by%20floating%20glowing%20playing%20cards%20and%20game%20tokens%2C%20bold%20clean%20lines%2C%20warm%20orange%20and%20deep%20teal%20palette%2C%20dramatic%20lighting%2C%20modern%20digital%20comic%20illustration%2C%20tense%20composition&width=900&height=1200&seq=comic-05&orientation=portrait",
  },
  {
    id: 6,
    title: "热血篮魂",
    author: "灌篮老炮",
    genre: "运动",
    latestChapter: "第 244 话 · 决胜一球",
    updateTime: "4 小时前",
    tags: ["今日更新", "热血运动"],
    cover: "https://readdy.ai/api/search-image?query=vibrant%20stylized%20sports%20basketball%20manga%20cover%20art%2C%20a%20determined%20young%20player%20dunking%20a%20basketball%20in%20a%20packed%20arena%2C%20bold%20clean%20lines%2C%20warm%20orange%20and%20teal%20palette%2C%20dynamic%20lighting%2C%20modern%20digital%20comic%20illustration%2C%20action%20packed%20composition&width=900&height=1200&seq=comic-06&orientation=portrait",
  },
  {
    id: 7,
    title: "阴阳茶馆",
    author: "茶语话本",
    genre: "灵异",
    latestChapter: "第 156 话 · 雨夜来客",
    updateTime: "5 小时前",
    tags: ["今日更新", "灵异志怪"],
    cover: "https://readdy.ai/api/search-image?query=vibrant%20stylized%20supernatural%20teahouse%20manga%20cover%20art%2C%20an%20elegant%20host%20serving%20tea%20to%20a%20ghostly%20customer%20in%20a%20warm%20ancient%20teahouse%2C%20bold%20clean%20lines%2C%20warm%20orange%20and%20deep%20teal%20palette%2C%20atmospheric%20lighting%2C%20modern%20digital%20comic%20illustration%2C%20moody%20composition&width=900&height=1200&seq=comic-07&orientation=portrait",
  },
  {
    id: 8,
    title: "厨房冒险家",
    author: "锅铲星辰",
    genre: "美食",
    latestChapter: "第 178 话 · 神秘大赛",
    updateTime: "6 小时前",
    tags: ["今日更新", "治愈美食"],
    cover: "https://readdy.ai/api/search-image?query=vibrant%20stylized%20gourmet%20cooking%20manga%20cover%20art%2C%20a%20cheerful%20young%20chef%20with%20sizzling%20wok%20and%20steaming%20delicious%20dishes%20around%20him%2C%20bold%20clean%20lines%2C%20warm%20orange%20and%20teal%20palette%2C%20bright%20appetizing%20lighting%2C%20modern%20digital%20comic%20illustration%2C%20playful%20composition&width=900&height=1200&seq=comic-08&orientation=portrait",
  },
];

export const hotSeries: Comic[] = [
  {
    id: 9,
    title: "山海神隐录",
    author: "神隐作者团",
    genre: "玄幻",
    latestChapter: "更新至 第 602 话",
    updateTime: "本周更新 3 话",
    hot: true,
    tags: ["爆款热更", "玄幻顶流"],
    cover: "https://readdy.ai/api/search-image?query=vibrant%20stylized%20mythical%20beast%20fantasy%20manga%20cover%20art%2C%20a%20hero%20riding%20a%20giant%20glowing%20mythical%20beast%20among%20floating%20mountains%20and%20clouds%2C%20bold%20clean%20lines%2C%20warm%20orange%20and%20deep%20teal%20palette%2C%20epic%20lighting%2C%20modern%20digital%20comic%20illustration%2C%20grand%20composition&width=900&height=1200&seq=comic-09&orientation=portrait",
  },
  {
    id: 10,
    title: "学院风云录",
    author: "青柠布丁",
    genre: "校园",
    latestChapter: "更新至 第 389 话",
    updateTime: "本周更新 5 话",
    hot: true,
    tags: ["爆款热更", "校园日常"],
    cover: "https://readdy.ai/api/search-image?query=vibrant%20stylized%20school%20life%20manga%20cover%20art%2C%20a%20group%20of%20energetic%20teenagers%20laughing%20on%20a%20campus%20staircase%20with%20cherry%20trees%2C%20bold%20clean%20lines%2C%20warm%20orange%20and%20teal%20palette%2C%20bright%20sunny%20lighting%2C%20modern%20digital%20comic%20illustration%2C%20fresh%20youthful%20composition&width=900&height=1200&seq=comic-10&orientation=portrait",
  },
  {
    id: 11,
    title: "万界快递员",
    author: "驿站站长",
    genre: "搞笑",
    latestChapter: "更新至 第 276 话",
    updateTime: "本周更新 4 话",
    tags: ["人气连载", "爆笑日常"],
    cover: "https://readdy.ai/api/search-image?query=vibrant%20stylized%20comedy%20fantasy%20manga%20cover%20art%2C%20a%20funny%20delivery%20boy%20carrying%20oversized%20packages%20through%20a%20portal%20between%20colorful%20worlds%2C%20bold%20clean%20lines%2C%20warm%20orange%20and%20teal%20palette%2C%20playful%20lighting%2C%20modern%20digital%20comic%20illustration%2C%20humorous%20composition&width=900&height=1200&seq=comic-11&orientation=portrait",
  },
  {
    id: 12,
    title: "破晓侦探社",
    author: "钟楼谜题",
    genre: "推理",
    latestChapter: "更新至 第 148 话",
    updateTime: "本周更新 2 话",
    tags: ["人气连载", "烧脑推理"],
    cover: "https://readdy.ai/api/search-image?query=vibrant%20stylized%20detective%20manga%20cover%20art%2C%20a%20sharp%20young%20detective%20with%20magnifying%20glass%20and%20floating%20clue%20symbols%20in%20a%20noir%20city%2C%20bold%20clean%20lines%2C%20warm%20orange%20and%20deep%20teal%20palette%2C%20moody%20dramatic%20lighting%2C%20modern%20digital%20comic%20illustration%2C%20mysterious%20composition&width=900&height=1200&seq=comic-12&orientation=portrait",
  },
  {
    id: 13,
    title: "机械之心",
    author: "齿轮小匠",
    genre: "机甲",
    latestChapter: "更新至 第 331 话",
    updateTime: "本周更新 3 话",
    tags: ["人气连载", "机甲热血"],
    cover: "https://readdy.ai/api/search-image?query=vibrant%20stylized%20mecha%20manga%20cover%20art%2C%20a%20young%20pilot%20standing%20with%20a%20giant%20sleek%20mech%20robot%20on%20a%20battlefield%20at%20dusk%2C%20bold%20clean%20lines%2C%20warm%20orange%20and%20teal%20palette%2C%20epic%20lighting%2C%20modern%20digital%20comic%20illustration%2C%20powerful%20composition&width=900&height=1200&seq=comic-13&orientation=portrait",
  },
  {
    id: 14,
    title: "甜心面包师",
    author: "奶油小方",
    genre: "恋爱",
    latestChapter: "更新至 第 205 话",
    updateTime: "本周更新 4 话",
    tags: ["人气连载", "甜宠恋爱"],
    cover: "https://readdy.ai/api/search-image?query=vibrant%20stylized%20romance%20bakery%20manga%20cover%20art%2C%20a%20gentle%20baker%20holding%20a%20heart%20shaped%20bread%20in%20a%20cozy%20warm%20bakery%2C%20bold%20clean%20lines%2C%20warm%20orange%20and%20teal%20palette%2C%20soft%20sweet%20lighting%2C%20modern%20digital%20comic%20illustration%2C%20lovely%20composition&width=900&height=1200&seq=comic-14&orientation=portrait",
  },
];

export interface ReminderFeature {
  icon: string;
  title: string;
  desc: string;
  tag: string;
}

export const reminderFeatures: ReminderFeature[] = [
  {
    icon: "ri-notification-3-line",
    title: "新章节推送提醒",
    desc: "收藏的漫画一更新，第一时间给你推送新章节，追更不断更、不迷路。",
    tag: "即时提醒",
  },
  {
    icon: "ri-bookmark-line",
    title: "收藏追更书架",
    desc: "一键收藏你正在追的连载，书架自动记录每一话阅读进度，随时续读。",
    tag: "进度同步",
  },
  {
    icon: "ri-refresh-line",
    title: "全网最新话同步",
    desc: "同步全网最新一话，热门连载、新番追更更新快人一步，不落后任何更新。",
    tag: "更新最快",
  },
  {
    icon: "ri-fire-line",
    title: "热门连载热榜",
    desc: "每日热门连载热榜实时更新，帮你发现大家都在追的高人气作品。",
    tag: "每日热榜",
  },
  {
    icon: "ri-eye-line",
    title: "高清原画畅读",
    desc: "高清原画章节，图片清晰不糊，阅读体验舒适流畅，看得过瘾。",
    tag: "高清原画",
  },
  {
    icon: "ri-user-smile-line",
    title: "免注册直接读",
    desc: "无需注册登录，打开就能直接阅读，随时随地开追，省心又省事。",
    tag: "即开即读",
  },
];

export const categories: { name: string; desc: string; count: number }[] = [
  { name: "玄幻仙侠", desc: "灵气复苏 · 御剑乘风", count: 3286 },
  { name: "都市异能", desc: "平凡逆袭 · 都市传说", count: 2910 },
  { name: "科幻机甲", desc: "星海远征 · 机械燃魂", count: 1834 },
  { name: "热血运动", desc: "青春赛场 · 一球成名", count: 987 },
  { name: "恋爱甜宠", desc: "心动日常 · 甜甜的恋爱", count: 2765 },
  { name: "悬疑推理", desc: "烧脑谜题 · 层层反转", count: 1520 },
  { name: "灵异志怪", desc: "阴阳两界 · 志怪奇谭", count: 1308 },
  { name: "治愈搞笑", desc: "轻松一刻 · 爆笑日常", count: 2114 },
  { name: "国漫新番", desc: "国漫崛起 · 新番不断", count: 2456 },
  { name: "日漫韩漫", desc: "海外精品 · 同步追更", count: 1789 },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "追更提醒是怎么工作的？",
    a: "你收藏的连载漫画只要有新章节更新，系统会第一时间为你推送更新提醒，并同步到你的追更书架，标记最新阅读话数。即使隔了几天再回来，也能从上次读到的地方无缝继续，完全不用担心追更断线。",
  },
  {
    q: "需要注册或付费才能追更吗？",
    a: "完全不需要。51免费漫画追更站坚持免费开放，无需注册登录即可直接阅读所有章节。收藏书架与追更提醒功能也全部免费使用，放心畅读。",
  },
  {
    q: "最新的更新话数准不准？",
    a: "我们的更新系统会同步全网最新话，连载、新番、海外精品都保持实时同步。遇到停更或推迟的情况，也会在作品详情页标明状态，让你清楚了解每一部作品的更新进度。",
  },
  {
    q: "在手机上看体验怎么样？",
    a: "站点采用响应式设计，手机、平板、电脑都能获得流畅的阅读体验。竖屏阅读、高清原画、目录跳转一应俱全，通勤路上也能轻松追更。",
  },
  {
    q: "怎么快速找到自己想看的漫画？",
    a: "你可以通过题材分类浏览，也可以使用搜索功能按作品名或作者查找。首页的今日更新与热门连载热榜，能帮你快速发现当下最值得追的作品。",
  },
];

export const testimonials: { name: string; role: string; quote: string }[] = [
  {
    name: "追更侠阿凯",
    role: "追了 5 年连载的老漫迷",
    quote: "以前老是忘记哪本更新到哪话了，现在收藏追更书架一开，新话立刻提醒，太省心了！",
  },
  {
    name: "深夜修仙党",
    role: "国漫新番爱好者",
    quote: "更新速度真的很快，最新话基本第一时间就能看到，还没注册就能直接读，太方便了。",
  },
  {
    name: "沙雕网友小林",
    role: "搞笑漫画重度用户",
    quote: "每天下班上来看看今日更新，笑点满满的日常漫画一个不落，追更神器没跑了。",
  },
];

export const stats: { value: string; label: string }[] = [
  { value: "12000+", label: "连载作品" },
  { value: "850 万+", label: "追更读者" },
  { value: "3000+", label: "每日更新" },
  { value: "99.9%", label: "同步时效" },
];